// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2bv5D","fileBtn":"File_fileBtn__3Akeh","closeBtn":"File_closeBtn__qlW1o","fileSelected":"File_fileSelected__1MDNo","disabled":"File_disabled__3LS7M"};